<!--
Author: TangChen
Date: 2018-10-18
Desc: 热销基金组件
 -->
<template>
    <div class="comp-hot-tab comp">
        <swiper v-if="!browserIE9" ref="mySwiper" :options="swiperOption">
            <swiper-slide
                v-for="(fund, index) in fundAll"
                :key="index"
                class="hot-tab"
                :index="index"
            >
                <el-card
                    class="hot-fund"
                    shadow="hover"
                    :style="{ 'border-color': fund.recommendtypecolor }"
                >
                    <label
                        v-cloak
                        class="label"
                        :style="{ 'background-color': fund.recommendtypecolor }"
                    >
                        {{ fund.recommendtype }}
                    </label>
                    <p
                        v-cloak
                        class="info"
                        style="cursor: pointer"
                        actiontype="toInfo"
                        :data="see(fund)"
                    >
                        {{ fund.fundname }}
                    </p>
                    <!-- <p v-cloak class="tit k-text-flow">
                        {{ fund.title }}
                    </p> -->
                    <p
                        v-cloak
                        class="reason k-text-flow"
                        style="cursor: pointer"
                        actiontype="toInfo"
                        :data="see(fund)"
                    >
                        {{ fund.reason }}
                    </p>
                    <div class="private-detail">
                        <!-- <p v-cloak class="info" :title="fund.fundname">
                            {{ (fund.fundname.length>12?fund.fundname.substr(0,10)+'...':fund.fundname)+'('+fund.fundcode+')' }}
                        </p> -->
                        <div v-if="!privateVal">
                            <p
                                class="data fund"
                                :class="$util.colorClass($util.fmtNum(fund[fund.incomefield]))"
                            >
                                {{ $util.fmtNum(fund[fund.incomefield]) }}
                                <span v-if="fund.field" v-cloak>{{ fund.field }}</span>
                            </p>
                            <p v-cloak class="data-t">
                                {{ fund.fieldText }}
                                <span>(更新:{{ $util.fmtDate(fund.navdate) }})</span>
                            </p>
                        </div>
                        <el-row v-else class="private-fund">
                            <el-col :span="8">
                                <p
                                    class="data"
                                    :class="$util.colorClass($util.fmtNum(fund[fund.incomefield]))"
                                >
                                    {{ $util.fmtNum(fund[fund.incomefield]) }}
                                    <span v-if="fund.field" v-cloak>{{ fund.field }}</span>
                                </p>
                                <p v-cloak class="data-t">
                                    {{ fund.fieldText }}
                                </p>
                            </el-col>
                            <el-col :span="8">
                                <span class="data">
                                    {{ fund.deadline ? fund.deadline : "&#45;&#45;" }}
                                </span>
                                <span class="data-t">投资期限</span>
                            </el-col>
                            <el-col :span="8">
                                <span class="data">
                                    100
                                    <span>万元</span>
                                </span>
                                <span class="data-t">投资起点</span>
                            </el-col>
                        </el-row>
                    </div>
                    <!-- 暂时禁用交易功能，汇款支付上线再放开（去掉注释） -->
                    <template
                        v-if="$util.getConfig().hideFunc && !$util.getConfig().onlyPrivateFund"
                    >
                        <div v-if="!privateVal" class="btn-group">
                            <el-tooltip
                                v-if="fund.isBuy"
                                class="item"
                                :class="{ 'all-one': fund.isCurrency }"
                                effect="info"
                                :content="fund.isBuy + ',不能购买'"
                                placement="left"
                            >
                                <el-button type="lock">立即购买</el-button>
                            </el-tooltip>
                            <!-- v-on:click="callbackFn('20,22',fund.fundcode)" -->
                            <el-button
                                v-else
                                actiontype="buy"
                                :data="see(fund)"
                                type="orange"
                                :class="{ 'all-one': fund.isCurrency }"
                            >
                                立即{{ fund.isBuy === "" ? "购买" : "认购" }}
                            </el-button>
                            <!-- v-on:click="callbackFn('59',fund.fundcode)" -->
                            <el-button
                                v-if="!fund.isCurrency"
                                actiontype="payment"
                                :data="see(fund)"
                                type="yellow"
                            >
                                我要定投
                            </el-button>
                        </div>
                        <div v-else class="btn-group private-btn">
                            <el-tooltip
                                v-if="fund.isBuy"
                                class="item"
                                :class="{ 'all-one': fund.isCurrency }"
                                effect="info"
                                :content="fund.isBuy + ',不能购买'"
                                placement="left"
                            >
                                <el-button type="lock">已售罄</el-button>
                            </el-tooltip>
                            <el-button
                                v-else
                                plain
                                :class="{ 'all-one': fund.isCurrency }"
                                actiontype="buy"
                                :data="see(fund)"
                            >
                                立即{{ fund.isBuy === "" ? "购买" : "认购" }}
                            </el-button>
                        </div>
                    </template>
                </el-card>
            </swiper-slide>
            <div
                v-if="fundInfo.length > 4 || (fundInfo.length > 4 && privateVal)"
                slot="button-prev"
                class="swiper-button-prev"
            >
                <i class="el-icon-arrow-left" aria-hidden="true" />
            </div>
            <div
                v-if="fundInfo.length > 4 || (fundInfo.length > 4 && privateVal)"
                slot="button-next"
                class="swiper-button-next"
            >
                <i class="el-icon-arrow-right" aria-hidden="true" />
            </div>
        </swiper>
        <div
            v-else
            ref="slideIe"
            class="slide-ie"
            style="height: 306px"
            v-on:mouseenter="stop"
            v-on:mouseleave="playSlide"
        >
            <div
                class="slide-ie-con"
                style="height: 306px"
                :style="{
                    width: (100 / swiperOption.slidesPerView) * fundAllIE.length + '%',
                    'margin-left': '-' + (indexIE * 1200) / swiperOption.slidesPerView + 'px'
                }"
            >
                <div
                    v-for="(fund, index) in fundAllIE"
                    :key="index"
                    class="slide-col"
                    :index="index"
                    :style="{ width: 1200 / swiperOption.slidesPerView + 'px' }"
                >
                    <el-card
                        class="hot-fund"
                        shadow="hover"
                        :style="{
                            'border-color': fund.recommendtypecolor,
                            'margin-right': swiperOption.spaceBetween + 'px'
                        }"
                    >
                        <label
                            v-cloak
                            class="label"
                            :style="{ 'background-color': fund.recommendtypecolor }"
                        >
                            {{ fund.recommendtype }}
                        </label>
                        <p
                            v-cloak
                            class="info"
                            style="cursor: pointer"
                            actiontype="toInfo"
                            :data="see(fund)"
                        >
                            {{ fund.fundname }}
                        </p>
                        <!-- <p v-cloak class="tit k-text-flow">
                            {{ fund.title }}
                        </p> -->
                        <p
                            v-cloak
                            class="reason k-text-flow"
                            style="cursor: pointer"
                            actiontype="toInfo"
                            :data="see(fund)"
                        >
                            {{ fund.reason }}
                        </p>
                        <div class="private-detail">
                            <!-- <p v-cloak class="info">
                                {{ fund.fundname+'('+fund.fundcode+')' }}
                            </p> -->
                            <div v-if="!privateVal">
                                <p
                                    class="data fund"
                                    :class="$util.colorClass($util.fmtNum(fund[fund.incomefield]))"
                                >
                                    {{ $util.fmtNum(fund[fund.incomefield]) }}
                                    <span v-if="fund.field" v-cloak>{{ fund.field }}</span>
                                </p>
                                <p v-cloak class="data-t">
                                    {{ fund.fieldText }}
                                    <span>(更新:{{ $util.fmtDate(fund.navdate) }})</span>
                                </p>
                            </div>
                            <el-row v-else class="private-fund">
                                <el-col :span="8">
                                    <p
                                        class="data"
                                        :class="
                                            $util.colorClass($util.fmtNum(fund[fund.incomefield]))
                                        "
                                    >
                                        {{ $util.fmtNum(fund[fund.incomefield]) }}
                                        <span v-if="fund.field" v-cloak>{{ fund.field }}</span>
                                    </p>
                                    <p v-cloak class="data-t">
                                        {{ fund.fieldText }}
                                    </p>
                                </el-col>
                                <el-col :span="8">
                                    <span class="data">
                                        {{ fund.deadline ? fund.deadline : "&#45;&#45;" }}
                                    </span>
                                    <span class="data-t">投资期限</span>
                                </el-col>
                                <el-col :span="8">
                                    <span class="data">
                                        100
                                        <span>万元</span>
                                    </span>
                                    <span class="data-t">投资起点</span>
                                </el-col>
                            </el-row>
                        </div>
                        <div v-if="!privateVal" class="btn-group">
                            <el-tooltip
                                v-if="fund.isBuy"
                                class="item"
                                :class="{ 'all-one': fund.isCurrency }"
                                effect="info"
                                :content="fund.isBuy + ',不能购买'"
                                placement="left"
                            >
                                <el-button type="lock">立即购买</el-button>
                            </el-tooltip>
                            <el-button
                                v-else
                                plain
                                :class="{ 'all-one': fund.isCurrency }"
                                v-on:click="callbackFn('20,22', fund.fundcode)"
                            >
                                立即{{ fund.isBuy === "" ? "购买" : "认购" }}
                            </el-button>
                            <el-button
                                v-if="!fund.isCurrency"
                                plain
                                class="blue"
                                actiontype="payment"
                                :data="see(fund)"
                            >
                                我要定投
                            </el-button>
                        </div>
                        <div v-else class="btn-group private-btn">
                            <el-tooltip
                                v-if="fund.isBuy"
                                class="item"
                                :class="{ 'all-one': fund.isCurrency }"
                                effect="info"
                                :content="fund.isBuy + ',不能购买'"
                                placement="left"
                            >
                                <el-button type="lock">已售罄</el-button>
                            </el-tooltip>
                            <el-button
                                v-else
                                type="blue"
                                :class="{ 'all-one': fund.isCurrency }"
                                v-on:click="callbackFn('20,22', fund.fundcode)"
                            >
                                立即{{ fund.isBuy === "" ? "购买" : "认购" }}
                            </el-button>
                        </div>
                    </el-card>
                </div>
            </div>
            <div
                v-if="fundInfo.length > 3 || (fundInfo.length > 3 && privateVal)"
                slot="button-prev"
                class="swiper-button-prev"
                v-on:click="move(-1)"
            >
                <i class="el-icon-arrow-left" aria-hidden="true" />
            </div>
            <div
                v-if="fundInfo.length > 3 || (fundInfo.length > 3 && privateVal)"
                slot="button-next"
                class="swiper-button-next"
                v-on:click="move(1)"
            >
                <i class="el-icon-arrow-right" aria-hidden="true" />
            </div>
        </div>
    </div>
</template>
<script>
import "swiper/dist/css/swiper.css"; // 这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    name: "HotTab",
    components: {
        swiper,
        swiperSlide
    },
    props: {
        fundInfo: {
            type: Array,
            required: true
        },
        privateVal: {
            type: Boolean,
            default: false
        }
    },
    data() {
        let self = this;
        return {
            timeIe: null,
            fundAll: [],
            fundAllIE: [],
            browserIE9: false,
            indexIE: 0,
            swiperOption: {
                // loop: true,
                observer: true, // 修改swiper自己或子元素时，自动初始化swiper
                observeParents: true,
                // 设定初始化时slide的索引
                initialSlide: 0,
                slidesPerView: 3,
                spaceBetween: 15,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                },
                on: {
                    slideChangeTransitionEnd: function () {
                        // 切换结束时，告诉我现在是第几个slide
                    },
                    click: function (e) {
                        let dom;
                        if (e.target.tagName == "SPAN") {
                            dom = e.target.parentNode;
                        } else {
                            dom = e.target;
                        }
                        let strData = dom.getAttribute("data");
                        if (strData == undefined || strData == "") {
                            return;
                        }
                        if (dom.getAttribute("actiontype") == "toInfo") {
                            let data = JSON.parse(strData);
                            self.gotoDetail(data);
                        } else if (dom.getAttribute("actiontype") == "buy") {
                            let data = JSON.parse(strData);
                            self.callbackFn("20,22", data.fundcode);
                        } else if (dom.getAttribute("actiontype") == "payment") {
                            let data = JSON.parse(strData);
                            self.callbackFn("59", data.fundcode);
                        }
                    }
                }
            }
        };
    },
    created() {
        this.getNewFund();
        if (this.fundInfo.length > 3 || (this.fundInfo.length > 3 && this.privateVal)) {
            this.swiperOption = Object.assign({}, this.swiperOption, {
                loop: true,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false
                }
            });
        }
        const theUA = window.navigator.userAgent.toLowerCase();
        if (
            (theUA.match(/msie\s\d+/) && theUA.match(/msie\s\d+/)[0]) ||
            (theUA.match(/trident\s?\d+/) && theUA.match(/trident\s?\d+/)[0])
        ) {
            const ieVersion =
                theUA.match(/msie\s\d+/)[0].match(/\d+/)[0] || theUA.match(/trident\s?\d+/)[0];
            if (ieVersion === "9") {
                this.browserIE9 = true;
                this.playSlide();
            }
        }
    },
    methods: {
        see(e) {
            return JSON.stringify(e);
        },
        gotoDetail(val) {
            this.$util.toCompPage("/fund", { secondtype: val.fundcode, etfflag: val.etfflag });
        },
        getNewFund() {
            const _arr = [];
            this.fundInfo.forEach((fund, index) => {
                const _x = Object.assign({}, fund);
                _x.recommendtypecolor = _x.recommendtypecolor || "#EF0F0F";
                _x.index = index + 1;
                _x.isBuy = this.$util.checkBuy(_x.status);
                _x.isCurrency = this.$util.checkGeneral(_x);
                if (fund.incomefield) {
                    const _z = this.$cache.getDict("90105", fund.incomefield);
                    let _a = [];
                    if (_z && _z.indexOf("|") > -1) {
                        _a = _z.split("|");
                        _x.fieldText = _a[0];
                        _x.field = _a[1];
                    } else {
                        _x.fieldText = _z;
                    }
                }
                _arr.push(_x);
            });
            this.fundAll = _arr;
            this.fundAllIE = _arr.concat(_arr[0], _arr[1], _arr[1]);
        },
        callbackFn(way, fundcode) {
            const fund = this.fundAll.filter((item) => {
                return item.fundcode === fundcode;
            });
            this.$emit("fund-continue", way, fund[0]);
        },
        move(v) {
            clearInterval(this.timeIe);
            if (v === -1) {
                if (this.indexIE === 0) {
                    this.indexIE = this.fundAll.length - 1;
                } else {
                    this.indexIE--;
                }
            } else {
                if (this.indexIE === this.fundAll.length - 1) {
                    this.indexIE = 0;
                } else {
                    this.indexIE++;
                }
            }
            if (!v) {
                this.playSlide();
            }
        },
        stop() {
            clearInterval(this.timeIe);
        },
        playSlide() {
            if (this.swiperOption.slidesPerView === this.fundAll.length) return;
            this.timeIe = setTimeout(() => {
                this.move();
            }, 3000);
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-hot-tab {
    .slide-ie {
        overflow: hidden;
        position: relative;
    }
    .slide-ie-con {
        &:after {
            content: "";
            clear: both;
            overflow: hidden;
            display: block;
            height: 0;
        }
        .slide-col {
            float: left;
            transition: all 0.8s ease-in-out;
        }
    }
    .hot-tab.swiper-slide,
    .slide-ie .slide-col {
        padding-top: 5px;
        &:hover {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }
    }
    .el-card {
        transition: all 0.5s ease;
        border-radius: 0;
        border: none;
        &.is-hover-shadow:hover {
            border-top: 3px solid $color-c;
            margin-top: -5px;
        }
    }
    .swiper-button-prev,
    .swiper-button-next {
        height: 36px;
        width: 36px;
        border-radius: 50%;
        background-color: rgba(31, 45, 61, 0.11);
        text-align: center;
        line-height: 36px;
        color: #ffffff;
        font-size: 1em;
        background-image: none;
        display: none;
    }
    .private-fund {
        padding: 10px 0 20px;
    }
    &:hover {
        .swiper-button-next,
        .swiper-button-prev {
            display: block;
        }
    }
    .hot-tab,
    .slide-col {
        overflow: hidden;
        .hot-fund {
            padding: 9px 25px;
            overflow: hidden;
            text-align: center;
            position: relative;
            .label {
                height: 26px;
                width: 100%;
                display: block;
                line-height: 26px;
                color: $text-color6;
                position: absolute;
                transform: rotate(-45deg);
                -ms-transform: rotate(-45deg);
                font-size: 12px;
                left: -167px;
                top: 12px;
            }
            .el-card__body {
                padding: 6px 0 20px;
            }
            .tit {
                font-size: $f16;
                line-height: 30px;
                color: $text-color2;
                height: 30px;
            }
            .reason {
                line-height: 24px;
                color: $text-color3;
                height: 24px;
            }
            .private-detail {
                margin-top: 16px;
                border-top: 1px solid #e3e9ee;
                padding: 10px 0 20px;
                text-align: center;
                .info {
                    font-size: $f18;
                    line-height: 34px;
                }
                .data,
                .data-t {
                    display: block;
                }
                .data {
                    line-height: 34px;
                    height: 34px;
                    font-size: 22px;
                    &.add {
                        color: $color-c;
                    }
                    &.reduce {
                        color: $color-d;
                    }
                    span {
                        font-size: $f14;
                    }
                }
                .fund.data {
                    line-height: 64px;
                    font-size: 50px;
                    height: 64px;
                }
                .data-t {
                    color: $text-color3;
                    line-height: 24px;
                }
            }
            .btn-group {
                &.private-btn {
                    .el-button {
                        border-style: solid;
                    }
                }
                .el-button {
                    padding: 0;
                    width: 45%;
                    font-size: $f16;
                    line-height: 32px;
                    &.all-one {
                        width: 100%;
                    }
                }
            }
        }
    }
}
</style>
